<template>
  <main class="home">
    <header class="header">
      <img
        class="is-hidden-desktop img-banner"
        src="../assets/images/banners/clientes_mobile.svg"
        alt=""
      />
      <div
        class="header__content-wrap column is-half-desktop is-offset-half-desktop"
      >
        <div class="header__content">
          <h2 class="color-primary mb-3">
            Monitores las cuentas por cobrar <br />
            y por pagar de tu negocio
          </h2>
          <p>
            Administrar tu negocio nunca fue tan sencillo. Olvidate de las horas
            interminables juntando comprobantes y verificando constancias de
            pago. ContaFácil permite hacer seguimiento a tus clientes y
            proveedores para que puedas enfocarte en lo más importante.
          </p>
          <div class="header__actions">
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
            <a class="button is-rounded bg-disabled" @click="setVideoDemo"
              >Video Demo</a
            >
          </div>
        </div>
      </div>
    </header>
    <tab-modules></tab-modules>
    <section class="section no-padding--left no-padding--right">
      <div class="columns is-desktop section__video section__video--column">
        <div class="text-wrap-aux bloque-inicial">
          <h3 class="color-primary">
            ContaFácil seguimiento continuo
          </h3>
          <img src="../assets/images/clientes_1.png" alt="" />
          <!-- <h3 class="color-primary is-hidden-desktop">
            ContaFácil seguimiento continuo
          </h3> -->
          <p>
            ContaFácil permite seguimiento continuo de los operaciones<br
              class="is-hidden-touch"
            />
            con tus <b>clientes y proveedores</b>. Envía recordarios y
            alertas<br class="is-hidden-touch" />
            para que te paguen a tiempo. Mantente actualizado sobre el<br
              class="is-hidden-touch"
            />
            estado de tu negocio.
          </p>
          <a
            rel="noopenner noreferer"
            class="button is-rounded bg-primary"
            href="https://app.contafacil.pe/#!/registro"
            @click="emitGlobalTriggerGtag('prueba_gratis')"
            >Prueba Gratis</a
          >
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--left">
        <div class="clientes column">
          <img src="../assets/images/clientes_2.png" alt />
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop"
        >
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Consulta RUC con la SUNAT
            </h3>
            <p>
              Valida la información de tus clientes<br
                class="is-hidden-touch"
              />
              y proveedores. Contafácil consulta la<br
                class="is-hidden-touch"
              />
              SUNAT la información al momento<br class="is-hidden-touch" />
              de registrar clientes y proveedores<br class="is-hidden-touch" />
              en tu negocio. Ten información<br class="is-hidden-touch" />
              importante a la mano como el<br class="is-hidden-touch" />
              estado del contribuyente y deuda<br class="is-hidden-touch" />
              coactiva.
            </p>
            <a
              rel="noopenner noreferer"
              class="button is-rounded button-mr-0 bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--right mar-top">
        <div class="clientes column column-50 column-offset-10">
          <img class="mal" src="../assets/images/clientes_3.png" alt />
        </div>
        <div class="video__text column is-two-fifths-desktop">
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Administra todo<br class="is-hidden-touch" />
              en un solo lugar
            </h3>
            <p>
              Información de comprobantes<br class="is-hidden-touch" />
              de acuerdo a sus estados de<br class="is-hidden-touch" />
              pago y listado de<br class="is-hidden-touch" />
              comprobantes históricos. <br />
              Contafácil permite ordenar tu<br class="is-hidden-touch" />
              negocio de la forma más<br class="is-hidden-touch" />
              sencilla.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-ml-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--left mar-top">
        <div class="clientes column column-50">
          <img class="fondo" src="../assets/images/clientes_4.png" alt />
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop-desktop"
        >
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Comparte reportes <br class="is-hidden-touch" />
              actualizados
            </h3>
            <p>
              Comparte reportes del estado<br class="is-hidden-touch" />
              de los comprobantes con tus<br class="is-hidden-touch" />
              clientes y proveedores. Envía<br class="is-hidden-touch" />
              recordatorios o aclaraciones <br class="is-hidden-touch" />en
              segundos.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-mr-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
    </section>
    <one-view></one-view>
  </main>
</template>

<script>
// @ is an alias to /src
import TabModules from "../components/TabModules";
import OneView from "../components/OneView";
import { EventBus } from "@/event-bus";
export default {
  name: "ClientesProveedores",
  components: {
    TabModules,
    OneView
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    },
    setVideoDemo() {
      EventBus.$emit("triggerGtag", "video_demo");
      this.$modal.show("video-demo", {
        src: `<iframe width="560" height="315" src="https://www.youtube.com/embed/AIQz9h5OaSg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.header {
  // background-image: url("../assets/images/banners/clientes_mobile.svg");
  // background-repeat: no-repeat;
  // background-size: 100% auto;
  // background-attachment: local;
  // background-origin: border-box;
  // height: calc(100vh - 75px);
  &__content-wrap {
    justify-content: flex-end;
    padding-bottom: 18%;
  }
  &__content {
    background-color: transparent;
    margin-top: auto;
    // height: 75%;
    width: 100%;
    p {
      width: 100%;
    }
  }
  @include tablet() {
    background-image: none;
    height: fit-content;
    // max-height: 600px;
    // padding: 4em 0;
    &__content {
      background-color: transparent;
      height: 90%;
      width: 100%;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1024px) {
    background-image: url("../assets/images/banners/clientes.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    height: calc(100vh - 100px);
    // max-height: 500px;
    &__content-wrap {
      // justify-content: center;
      padding-bottom: 0%;
    }
    &__content {
      background-color: transparent;
      height: 70%;
      width: 100%;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1200px) {
    background-image: url("../assets/images/banners/clientes.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    height: calc(100vh - 100px);
    // max-height: 690px;
  }
  @media (min-width: 1800px) {
    background-image: url("../assets/images/banners/clientes.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    height: calc(100vh - 120px);
    // max-height: 1230px;
  }
}
.section {
  // padding: 3rem;
  padding-top: 0px;
  // .button {
  //   font-size: 16px;
  //   font-weight: 500;
  // }
  h2 {
    font-weight: bold;
    // font-size: 3rem;
  }
  @include laptop() {
    margin-top: 3rem;
  }
  &__video {
    width: 100%;
    margin: 1rem 0px;
    // min-height: 560px;
    // display: flex;
    // flex-flow: column nowrap;
    // justify-content: flex-start;
    // align-items: stretch;
    @include laptop() {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: stretch;
      margin: 4em 0px;
    }
    @include desktop() {
      margin: 7em 0px;
    }
    .video__text {
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
      // order: 2;
      &--right {
        text-align: center;
        align-items: flex-end;
      }
      h3 {
        letter-spacing: 0.05em;
        font-size: 16px;
        width: 100%;
        font-weight: bold;
        margin: 2em auto;
      }
      p {
        width: 90%;
        font-size: 16px;
        letter-spacing: 0.025em;
        font-weight: 400;
        margin: 2em auto;
      }
      .button {
        margin: 1rem auto;
      }
      @include tablet() {
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: center;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          width: 90%;
          font-weight: bold;
        }
        p {
          width: 90%;
          font-size: 1.5rem;
        }
        .button {
          // width: 200px;
          font-size: 1.2rem;
          margin: 1rem auto;
        }
      }
      @media (min-width: 1024px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        order: 0;
        &--right {
          text-align: right;
          align-items: flex-end;
          order: 1;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.3rem;
          line-height: 1.2;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.2rem;
          line-height: 1.2;
          letter-spacing: 0.075em;
          font-weight: 400;
          margin: 1em 0;
          // margin: 1.5rem 0;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.4rem;
          line-height: 1.2;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.4rem;
          line-height: 1.2;
          letter-spacing: 0.075em;
          font-weight: 400;
          // margin: 1.5rem 0;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop-medium() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.5rem;
          line-height: 1.2;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.5rem;
          line-height: 1.2;
          letter-spacing: 0.075em;
          font-weight: 400;
          // margin: 1.5rem 0;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @media (min-width: 1800px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          font-size: 1.2rem;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
    }
    .video__player,
    .video-mini__player {
      order: 1;
      background-image: url("../assets/images/video-placeholder.png");
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      @include laptop() {
        // order: 0;
      }
    }
    .clientes {
      padding: 0px;
      order: 1;
      @include tablet() {
        display: flex;
        align-items: flex-start;
        img {
          max-width: none;
          width: 100%;
          // height: auto;
          object-fit: contain;
        }
      }
      @include laptop() {
        // display: flex;
        img {
          max-width: none;
          width: 100%;
          // height: auto;
          object-fit: contain;
        }
      }
    }
    .video-mini__player {
      height: 300px;
    }
    .video-mini__text {
      margin: 0 auto;
      margin-top: 3rem;
      width: 75%;
      h3 {
        letter-spacing: 0.018em;
        font-size: 2.2rem;
        font-weight: bold;
      }
      p {
        font-size: 1.8rem;
      }
    }
    &:first-child {
      padding-top: 0px;
    }
    &--column {
      width: 90%;
      margin: 0 auto;
      flex-flow: column nowrap;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 5em;
      h3 {
        letter-spacing: 0.05em;
        font-size: 16px;
        font-weight: bold;
        margin: 2em auto;
      }
      p {
        font-size: 14px;
        letter-spacing: 0.025em;
        margin: 2em auto;
      }
      .button {
        margin: 1rem auto;
      }
      .video__player {
        width: 100%;
        height: 500px;
      }
      img {
        max-width: 650px;
        width: 100%;
      }
      @include tablet() {
        width: 100%;
        padding: 1rem;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
          letter-spacing: 0.025em;
        }
        img {
          width: 95%;
        }
        .button {
          // max-width: 200px;
          font-size: 1.2rem;
          // margin: 1rem auto;
        }
      }
      @include laptop() {
        width: 100%;
        padding: 1rem;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.3rem;
          letter-spacing: 0.05em;
          margin: 2rem auto;
        }
        img {
          max-width: none;
          width: 700px;
        }
        .button {
          max-width: 200px;
          font-weight: bold;
          width: fit-content;
          // margin: 1rem auto;
        }
      }
      @include desktop() {
        width: 100%;
        padding: 1rem;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.4rem;
          font-weight: bold;
        }
        p {
          font-size: 1.4rem;
          letter-spacing: 0.05em;
          margin: 2rem auto;
        }
        img {
          width: 900px;
        }
        .button {
          max-width: 200px;
          font-weight: bold;
          width: fit-content;
          // margin: 1rem auto;
        }
      }
      @include desktop-medium() {
        width: 100%;
        padding: 1rem;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
          letter-spacing: 0.05em;
          margin: 2rem auto;
        }
        img {
          width: 900px;
        }
        .button {
          max-width: 200px;
          font-weight: bold;
          width: fit-content;
          // margin: 1rem auto;
        }
      }
      @include desktop-large() {
        width: 100%;
        padding: 1rem;
        h3 {
          letter-spacing: 0.05em;
          font-size: 2rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.05em;
          margin: 1em auto;
        }
        img {
          width: 40%;
        }
        .button {
          max-width: none;
          font-weight: bold;
          width: fit-content;
          // margin: 1rem auto;
          font-size: 1.5rem;
        }
      }
    }
    @include laptop() {
      // margin: 4rem auto;
    }
  }
}
.factura-img {
  display: block;
  width: 500px;
  margin: 4rem auto;
}
.bloque-inicial {
  h3 {
    margin: 1em auto 2em;
  }
  p {
    margin: 2em auto;
  }
  @include laptop() {
    h3 {
      margin: 1em auto 3em;
    }
    p {
      margin: 4.5em auto 1em;
    }
  }
}
</style>
